import _AssignValue from './assign-value/index';

export const AssignValue = _AssignValue;